import { useEffect, useState } from "react";
import { getDomainName } from "keycloakService";

export default function useDomainBranding() {
	const [branding, setBranding] = useState({
		domain: localStorage.getItem("domain") || "",
		domainId: localStorage.getItem("domain_id") || "",
		logo: localStorage.getItem("logo") || "",
		loginImage: localStorage.getItem("loginImage") || "",
		footer: localStorage.getItem("footer") || "",
		loginComponent: localStorage.getItem("domainLoginComponent") || "/",
	});
	const [brandingReady, setBrandingReady] = useState(false);

	useEffect(() => {
		let cancelled = false;

		if (window.__brandingBootstrapped) {
			setBrandingReady(true);
			return;
		}
		window.__brandingBootstrapped = true;

		(async () => {
			try {
				const d = await getDomainName();
				if (cancelled) return;

				const next = {
					domain: d?.DomainName ?? "",
					domainId: d?.id ?? "",
					logo: d?.Logo ?? "",
					footer: d?.FooterText ?? "",
					loginImage: d?.LoginImage ?? "",
					loginComponent: d?.LoginComponent ?? "/",
				};

				localStorage.setItem("domain", next.domain);
				localStorage.setItem("domain_id", next.domainId);
				localStorage.setItem("logo", next.logo);
				localStorage.setItem("loginImage", next?.loginImage);
				localStorage.setItem("footer", next.footer);
				localStorage.setItem("domainLoginComponent", next.loginComponent);

				setBranding(next);
			} catch {
			} finally {
				if (!cancelled) setBrandingReady(true);
			}
		})();

		return () => {
			cancelled = true;
		};
	}, []);

	return { branding, brandingReady };
}
